<template>
  <div v-if="vuexPolicyFields.length > 0">
    <FITFormCard>
      <b-row slot="header" align-v="center">
        <b-col>
          <h5><i class="fa fa-file mr-2"></i>{{$t('osm.contents.giPolicy.policyInfo')}}</h5></b-col>
      </b-row>
      <div slot="formBody">
        <b-row>
          <b-col cols="6">
            <template v-for="field in getTranslatedPolicyFields(locale)">
              <component :disabled="policyInfoStatus.disabled" v-if="field.type === 'string'" is="FITTextInput" type="text" :width="8" :label="$t(`osm.contents.giPolicy.productInformation.${field.fieldName}`)" @input="onInputChange" v-model="giTypeInfo[field.fieldName]"></component>
              <component :disabled="policyInfoStatus.disabled" v-else-if="field.type === 'number'" is="FITTextInput" type="number" :width="8" :label="$t(`osm.contents.giPolicy.productInformation.${field.fieldName}`)" @input="onInputChange" v-model="giTypeInfo[field.fieldName]"></component>
              <component :disabled="policyInfoStatus.disabled" v-else-if="field.type === 'selection'" is="FITSelect" :options="field.options" :width="8" :label="$t(`osm.contents.giPolicy.productInformation.${field.fieldName}`)" @input="onInputChange" v-model="giTypeInfo[field.fieldName]"></component>
            </template>
          </b-col>
        </b-row>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITTextInput, FITSelect } from '@/components'
import { mapState, mapGetters } from 'vuex'
import Vue from 'vue'
export default {
  name: 'NewGIPolicyPolicyInfo',
  components: {
    FITFormCard,
    FITTextInput,
    FITSelect
  },
  computed: {
    ...mapState({
      vuexPolicyFields: state => state.GIPolicy.newGI.policyFields,
      policyInfoStatus: state => state.GIPolicy.newGI.fields.policyInfomation,
      vuexGiTypeInfo: state => state.GIPolicy.newGI.giTypeInfo,
      workflowCurrentIndex: state => state.GIPolicy.newGI.workflowCurrentStep
    }),
    ...mapGetters("GIPolicy", [
      'getTranslatedPolicyFields'
    ]),
    locale() {
      return this.$i18n.locale;
    }
  },
  created() {

  },
  watch: {
    vuexGiTypeInfo(newData, oldData) {
      console.debug("giTypeInfo")
      console.debug(newData);
      Vue.set(this, 'giTypeInfo', newData);
    },
    vuexPolicyFields(newData, oldData) {
      //create obj for type fields
      if (this.workflowCurrentIndex > 0) {
        return;
      }
      var infoFields = {};
      let newFields = newData.slice();
      for (var i = 0; i < newFields.length; i++) {
        var newField = {};
        var item = newFields[i];
        switch (item.type) {
          case 'string':
            newField = {
              [item.field]: ''
            }
            break;
          case 'number':
            newField = {
              [item.field]: 0
            }
            break;
          case "selection":
            newField = {
              [item.field]: null
            }
            break;
        }
        infoFields = {
          ...infoFields,
          ...newField
        }
        if (item.field == 'version') {
          newFields.splice(i, 1);
        }
      }
      Vue.set(this, 'giTypeInfo', infoFields);
      // Vue.set(this.giTypeInfo, 'version', 1);
    },
    giTypeInfo: {
      handler(newData, oldData) {
        console.log(newData);
        this.onInputChange(newData);
      },
      deep: true
    }
  },
  data() {
    return {
      giTypeInfo: {},
    }
  },
  methods: {
    onInputChange(newData) {
      this.$emit('input', newData);
    },
    saveToVuex() {
      console.debug(this.giTypeInfo);
      this.$store.commit({ type: 'GIPolicy/setGITypeInfo', giTypeInfo: this.giTypeInfo })
    }
  },
  destroyed() {
    // Object.assign(this.$data, this.$options.data.apply(this))

  }

}

</script>



// WEBPACK FOOTER //
// src/Osm/GIPolicy/components/NewGIPolicy/NewGIPolicyPolicyInfo.vue